import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { Subject, takeUntil } from 'rxjs';
import { CustomGroupSocketCommands } from 'ops/common/io-event/websocket-message';
import { CustomGroupAccessEvents } from 'ops/common/models/access-settings';

@Injectable({ providedIn: 'root' })
export class CustomGroupSocketService {
    destroySubscriptions$: Subject<void> = new Subject();
    updateGroupList$: Subject<string> = new Subject<string>();

    constructor(private socketService: SocketMiddlewareService) {}

    startSubscriptions() {
        this.subscribeToEvent(this.customGroupCreated());
        this.subscribeToEvent(this.customGroupDeleted());
        this.subscribeToEvent(this.customGroupUpdated());
        this.subscribeToEvent(this.accessSettingsUpdated());
    }

    private subscribeToEvent(event$) {
        event$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((groupId) => {
            this.updateGroupList$.next(groupId);
        });
    }

    destroySubscriptions() {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    updateListSubject(): Subject<string> {
        return this.updateGroupList$;
    }

    customGroupCreated() {
        return this.socketService.receiveMessageObserver(CustomGroupSocketCommands.GROUP_CREATED);
    }

    customGroupDeleted() {
        return this.socketService.receiveMessageObserver(CustomGroupSocketCommands.GROUP_DELETED);
    }

    customGroupUpdated() {
        return this.socketService.receiveMessageObserver(CustomGroupSocketCommands.GROUP_UPDATED);
    }

    accessSettingsUpdated() {
        return this.socketService.receiveMessageObserver(
            CustomGroupAccessEvents.CustomGroupAccessUpdated,
        );
    }
}
